export function SET_BOOKINGS_ORDERS (state, data) {
    state.bookingsOrders = data.bookingorders
}

export function SET_BOOKINGS_REQUESTS (state, data) {
    state.bookingsRequests = data.bookingrequests
}